<template>
  <div class="navbar-bookmarks flex items-center">
    <!-- STARRED PAGES MORE -->
    <div class="vx-navbar__starred-pages--more-dropdown">
      <feather-icon @click="popupActivo=true" icon="ChevronDownIcon" svgClasses="h-4 w-4" class="cursor-pointer p-2"></feather-icon><span class="cursor-pointer" @click="popupActivo=true">{{ selectedConferenceName || 'Konferensiyani tanlang' }}</span>
    </div>
    <vs-popup class="holamundo"  title="Konferensiyalardan bittasiga o'ting" :active.sync="popupActivo">
      <ul class="vx-navbar__starred-pages-more--list">
        <li class="starred-page--more flex items-center cursor-pointer" style="margin-bottom: 30px">
          <vs-radio v-model="selectedConference" @click="allSelect()" :vs-name="'Barchasi'" :vs-value="''"><span @click="allSelect()" class="px-2 pt-2 pb-1">{{ 'Barcha konferensiya' }}</span></vs-radio>
        </li>
        <li class="starred-page--more flex items-center cursor-pointer" style="margin-bottom: 30px" v-for="(conference, index) in conferences" :key="index">
          <vs-radio v-model="selectedConference" @click="selectConference(conference)" :vs-name="conference.name" :vs-value="conference.id"><span @click="selectConference(conference)" class="px-2 pt-2 pb-1">{{ conference.name }}</span></vs-radio>
        </li>
      </ul>
    </vs-popup>
  </div>
</template>

<script>
import draggable     from 'vuedraggable'
import VxAutoSuggest from '@/components/vx-auto-suggest/VxAutoSuggest.vue'
import axios from 'axios'

export default {
  props: {
    navbarColor: {
      type: String,
      default: '#fff'
    }
  },
  components: {
    draggable,
    VxAutoSuggest
  },
  data () {
    return {
      popupActivo: false,
      selectedConference: '',
      selectedConferenceName: '',
      conferences: []
    }
  },
  created () {
    this.loadList()
    this.loadConference()
  },
  computed: {
    navbarSearchAndPinList () {
      return {pages: this.$store.state.navbarSearchAndPinList['pages']}
    },
    starredPages () {
      return this.$store.state.starredPages
    },
    textColor () {
      return {'text-white': this.$store.state.mainLayoutType === 'vertical' && this.navbarColor !== (this.$store.state.theme === 'dark' ? '#10163a' : '#fff') }
    }
  },
  methods: {
    allSelect () {
      this.selectedConference = ''
      this.selectedConferenceName = ''
      window.localStorage.removeItem('selectedConference')
      window.localStorage.removeItem('selectedConferenceName')
      window.location.reload()
    },
    loadConference () {
      const selectedConference = window.localStorage.getItem('selectedConference')
      const selectedConferenceName = window.localStorage.getItem('selectedConferenceName')
      this.selectedConference = (selectedConference) ? parseInt(selectedConference) : ''
      this.selectedConferenceName = selectedConferenceName
    },
    selectConference (conference) {
      this.selectedConference = conference.id
      this.selectedConferenceName = conference.name
      window.localStorage.setItem('selectedConference', this.selectedConference)
      window.localStorage.setItem('selectedConferenceName', conference.name)
      window.location.reload()
    },
    loadList () {
      axios
        .get('https://api.conferences-list.uz/api/v1/conferences')
        .then(response => {
          const { data } = response.data
          this.conferences = data
        })
    },
    selected (obj) {
      this.$store.commit('TOGGLE_CONTENT_OVERLAY', false)
      this.$router.push(obj.pages.url).catch(() => {})
    },
    actionClicked (item) {
      this.$store.dispatch('updateStarredPage', { url: item.url, val: !item.is_bookmarked })
      // this.$refs.bookmarkAutoSuggest.filterData()
    },
    hnd_search_query_update (query) {
      // Show overlay if any character is entered
      this.$store.commit('TOGGLE_CONTENT_OVERLAY', !!query)
    }
  },
  directives: {
    'click-outside': {
      bind (el, binding) {
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          /* eslint-disable no-mixed-operators */
          if (bubble || !el.contains(e.target) && el !== e.target) {
          /* eslint-enable no-mixed-operators */
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler
        document.addEventListener('click', handler)
      },

      unbind (el) {
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null

      }
    }
  }
}

</script>
